import './cart-total-updater';
import './sidebar-cart';
import './dynamic-my-account-title';
import './add-quantity';
import './masonry-reviews';
